enum FilterLogic {
  Equal = "equal",
  NotEqual = "notEqual",
  Greater = "greater",
  Less = "less",
  GreaterOrEqual = "greaterOrEqual",
  LessOrEqual = "lessOrEqual",
  Contains = "contains",
  StartsWith = "startsWith",
  EndsWith = "endsWith",
}

export default FilterLogic;
